const TechnicalsCell = ({ value }) =>
  `${value.supporting} / ${value.conflicting}`;

export default TechnicalsCell;
